import { useCallback, useReducer, useState } from "react";
import {
  initialState,
  JobPendingApprovalReducer,
} from "./pendingapproval.reducer";
import { getJobApprovals, pendingApprovaliData } from "../api/job_api";
import {
  setCount,
  setPendingApprovals,
  setSTATUSToast,
} from "./pendingAction.action";

export const useJobsPendingappprovalViewModel = () => {
  const [state, dispatch] = useReducer(JobPendingApprovalReducer, initialState);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(8);
  const showToastMessage = (
    message: string,
    type: "success" | "error" | "warning" | "info",
  ) => dispatch(setSTATUSToast({ isVisible: true, message, type }));
  const hideToastMessage = () =>
    dispatch(
      setSTATUSToast({ isVisible: false, message: "", type: "success" }),
    );
  const loadPendingApprovals = useCallback(async (
    page = currentPage,
    limit = rowsPerPage,
  ) => {
    try {
      const skip = (page - 1) * limit;
      const resp = await pendingApprovaliData({ skip, limit });
      const totalCount = Number(
        resp.headers?.["x-total-count"] ?? resp.data.count ?? 0,
      );

      dispatch(setPendingApprovals(resp.data.pending_approvals));
      dispatch(setCount(totalCount));

      const totalPages = Math.max(1, Math.ceil(totalCount / limit));
      if (page > totalPages) {
        setCurrentPage(totalPages);
      }
    } catch (error) {
      console.log(error);
    }
  }, [currentPage, rowsPerPage]);
  // const jobApprovalData = async (jobId: any, ) => {
  //   try {
  //     const payload = {
  //       action: "string",
  //       comments: "",
  //     };
  //     await getJobApprovals(jobId, payload);
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };
  const [rejectModal, setRejectModal] = useState<{
    jobId: string;
    comment: string;
  } | null>(null);

  const openRejectModal = (jobId: string) =>
    setRejectModal({ jobId, comment: "" });
  const closeRejectModal = () => setRejectModal(null);

  const handleJobApproval = async (
    jobId: string,
    action: "approve" | "reject",
    comment = "",
  ) => {
    try {
      const payload = {
        action,
        comments: comment,
      };

      await getJobApprovals(jobId, payload);

      const nextPage =
        state.pendingApprovals.length === 1 && currentPage > 1
          ? currentPage - 1
          : currentPage;

      if (nextPage !== currentPage) {
        setCurrentPage(nextPage);
      } else {
        await loadPendingApprovals(currentPage, rowsPerPage);
      }
      showToastMessage(
        action === "approve"
          ? "Job approved successfully"
          : "Job rejected successfully",
        "success",
      );
      // toast.success(action === "approve" ? "Job approved successfully" : "Job rejected successfully");
    } catch (error: any) {
      console.error(error);
      const apiMessage =
        error?.response?.data?.message ||
        error?.message ||
        "Something went wrong";

      showToastMessage(apiMessage, "error");
    }
  };

  const handlePageChange = (page: number) => {
    setCurrentPage(Math.max(1, page));
  };

  const handleRowsPerPageChange = (rows: number) => {
    setRowsPerPage(Math.max(1, rows));
    setCurrentPage(1);
  };

  return {
    loadPendingApprovals,
    state,
    dispatch,
    handleJobApproval,
    hideToastMessage,
    rejectModal,
    setRejectModal,
    openRejectModal,
    closeRejectModal,
    currentPage,
    rowsPerPage,
    handlePageChange,
    handleRowsPerPageChange,
  };
};
